export var OfferingType;
(function (OfferingType) {
    OfferingType["INDIVIDUAL"] = "INDIVIDUAL";
    OfferingType["GROUP"] = "GROUP";
    OfferingType["TOUR"] = "TOUR";
    OfferingType["COURSE"] = "COURSE";
    OfferingType["DUMMY"] = "DUMMY";
})(OfferingType || (OfferingType = {}));
export var OfferedAsType;
(function (OfferedAsType) {
    OfferedAsType["ONE_TIME"] = "ONE_TIME";
    OfferedAsType["PRICING_PLAN"] = "PRICING_PLAN";
})(OfferedAsType || (OfferedAsType = {}));
//# sourceMappingURL=offering.dto.js.map